import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Upload,
  Avatar,
  Row,
  Col,
  Typography,
  Space,
  Select,
  message,
  Tag
} from "antd";
import { PhoneOutlined, UserOutlined, IdcardOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import useExpertProfile from "PlatForms/Dashboards/ExpertDashboard/Hooks/useExpertProfle";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import { toast } from "react-toastify";

const { Text } = Typography;
const { Option } = Select;

const ExpertProfile = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { isProfileComplete, fetchProfileStatus } = React.useContext(ProfileContext);

  // Country, State, City States
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [ yearsOfExperience , setYearsOfExperience] = useState(null);
  

  const {
    profileData,
    loading,
    updating,
    imageUrl,
    fileList,
    beforeUpload,
    handleImageChange,
    updateProfile,
    removeProfilePicture,
    removingImage,
  } = useExpertProfile(form);

  useEffect(() => {
    // Initialize countries
    const allCountries = Country.getAllCountries();
    setCountries(allCountries);

  }, []);



  

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    const relatedStates = State.getStatesOfCountry(value);
    setStates(relatedStates);
    setCities([]);
    form.setFieldsValue({ state: undefined, city: undefined });
  };

  const handleStateChange = (value) => {
    setSelectedState(value);
    const relatedCities = City.getCitiesOfState(selectedCountry, value);
    setCities(relatedCities);
    form.setFieldsValue({ city: undefined });
  };

  // Set form initial values when profileData is available
  useEffect(() => {
    if (profileData && !loading) {
      console.log("Setting form values with profile data:", profileData);
      
        form.setFieldsValue({
        firstName: profileData.firstName || "",
        lastName: profileData.lastName || "",
        phoneNo: profileData.phoneNo || "",
        country: profileData.country,
        state: profileData.state,
        city: profileData.city,
        yearsOfExperience:profileData.yearsOfExperience
      });

      // If country exists in profile, load its states
      if (profileData.country) {
        setSelectedCountry(profileData.country);
        const relatedStates = State.getStatesOfCountry(profileData.country);
        setStates(relatedStates);

        // If state exists in profile, load its cities
        if (profileData.state) {
          setSelectedState(profileData.state);
          const relatedCities = City.getCitiesOfState(profileData.country, profileData.state);
          setCities(relatedCities);
        }
      }
    }
  }, [profileData, loading, form]);
  console.log("Profile data", profileData)

  

  const handleFormSubmit = async (values) => {
    try {
      console.log("Form values:", values);

      
      // Ensure all required fields are included
      const formValues = {
        ...values,
        };

      console.log("Form values to submit:", formValues);

      const success = await updateProfile(formValues, navigate);
      console.log("UpdateProfile returned:", success);

      // Check if profile is complete after update
      if (success) {
        toast.success("Profile updated successfully!");

        // Fetch the latest profile status
        await fetchProfileStatus();

        // Navigate to dashboard
        setTimeout(() => {
          navigate("/expert-dashboard");
        }, 1000);
      } else {
        message.error("Failed to update profile");
      }
    } catch (error) {
      console.error("Error in handleFormSubmit:", error);
      toast.error(error || "An error occurred while updating your profile");
    }
  };

  return (
   <Card
  loading={loading}
  title="Expert Profile"
  className="card-professional"
>
      <Form 
        form={form} 
        layout="vertical" 
        onFinish={handleFormSubmit}
     //   onValuesChange={onValuesChange}
      >
        <Row gutter={[32, 16]} align="middle">
  <Col xs={24} md={6} style={{ textAlign: "center" }}>
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      height: '100%'
    }}>
      {/* Learner ID Section - Beside the image */}
      <div style={{ 
        marginBottom: 20, 
        textAlign: 'center',
        width: '100%'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          marginBottom: 8 
        }}>
                  <Text strong style={{ fontSize: '14px' }}>Expert ID</Text>
        </div>
        <Tag 
          color="gold" 
          style={{ 
            fontSize: '14px', 
            fontWeight: 'bold',
            padding: '4px 12px',
            borderRadius: '4px',
            marginBottom: 4
          }}
        >
          {profileData?.expertCode || 'N/A'}
        </Tag>
        <div>
          <Text type="secondary" style={{ fontSize: '11px' }}>
            Unique identification
          </Text>
        </div>
      </div>
      
      {/* Profile Image Section */}
      <Form.Item name="imageFile" style={{ marginTop: 'auto' }}>
        <Upload
          name="imageFile"
          listType="picture-card"
          showUploadList={false}
          beforeUpload={beforeUpload}
          onChange={handleImageChange}
          fileList={fileList}
          accept="image/*"
        >
          {imageUrl ? (
            <Avatar src={imageUrl} size={110} style={{ border: "2px solid #eee" }} />
          ) : (
            <Avatar
              icon={<UserOutlined />}
              size={110}
              style={{ backgroundColor: "#f0f0f0" }}
            />
          )}
        </Upload>
        <Text type="secondary">Click to change &middot; JPG or PNG, up to 1MB</Text>
        {imageUrl && (
          <div style={{ marginTop: 8 }}>
            <Button size="small" danger loading={removingImage} onClick={removeProfilePicture}>
              Remove photo
            </Button>
          </div>
        )}
      </Form.Item>
    </div>
  </Col>
   <Col xs={24} md={18}>
            <Row gutter={16}>
          

              <Col xs={24} md={12}>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[{ required: true, message: "Please input your first name!" }]}
                >
                  <Input placeholder="John" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[{ required: true, message: "Please input your last name!" }]}
                >
                  <Input placeholder="Doe" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="Email">
                  <Input value={profileData?.email || ""} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Phone Number"
                  name="phoneNo"
                  rules={[
                    { required: true, message: "Please enter your phone number!" },
                    {
                      pattern: /^\+?[0-9\s]*$/,
                      message: "Please enter only numbers and optional + prefix!",
                    },
                  ]}
                >
                  <Input
                    type="tel"
                    prefix={<PhoneOutlined />}
                    placeholder="+1234567890"
                    onKeyPress={(e) => {
                      if (!/[0-9+]/.test(e.key) && e.key !== "Backspace") e.preventDefault();
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if ((value.match(/\+/g) || []).length > 1) {
                        e.target.value = value.replace(/\+/g, "");
                        if (value.startsWith("+")) e.target.value = "+" + e.target.value;
                      }
                    }}
                  />
                </Form.Item>
              </Col>


              {/* Country */}
              <Col xs={24} md={12}>
                <Form.Item
                  label="Country"
                  name="country"
                  rules={[{ required: true, message: "Please select your country!" }]}
                >
                  <Select
                    showSearch
                    placeholder="Select your country"
                    optionFilterProp="children"
                    onChange={handleCountryChange}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={countries.map((country) => ({
                      label: country.name,
                      value: country.isoCode,
                    }))}
                  />
                </Form.Item>
              </Col>

              {/* State */}
              <Col xs={24} md={12}>
                <Form.Item
                  label="State"
                  name="state"
                  rules={[
                    {
                      required: selectedCountry === "US",
                      message: "State is required when country is United States!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select your state"
                    optionFilterProp="children"
                    onChange={handleStateChange}
                    disabled={!selectedCountry}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={states.map((state) => ({
                      label: state.name,
                      value: state.isoCode,
                    }))}
                  />
                </Form.Item>
              </Col>

              {/* City */}
              <Col xs={24} md={12}>
                <Form.Item
                  label="City"
                  name="city"
                  rules={[
                    {
                      required: cities.length > 0,
                      message: "Please select your city!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select your city"
                    optionFilterProp="children"
                    disabled={!selectedState}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={cities.map((city) => ({
                      label: city.name,
                      value: city.name,
                    }))}
                  />
                </Form.Item>
              </Col>
    {/* YearsOfExperience */}
<Col xs={24} md={12}>
  <Form.Item
    label="Years of Experience"
    name="yearsOfExperience"
    rules={[
      { required: true, message: 'Please select your years of experience!' },
    ]}
  >
    <Select
      placeholder="Select years of experience"
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toString().includes(input)
      }
    >
      {Array.from({ length: 51 }, (_, i) => i).map((year) => (
        <Select.Option
          key={year}
          value={Number(year)} // ✅ numeric value
          label={year}
        >
          {year} {year === 1 ? 'year' : 'years'}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
</Col>


              <Col xs={24}>
                <Form.Item>
                  <Space>
                    <Button type="primary" htmlType="submit" loading={updating}>
                      Update Profile
                    </Button>
                    <Button
                      onClick={() => {
                        form.resetFields();
                        // Re-set initial values from profile data
                        if (profileData) {
                          form.setFieldsValue({
                            firstName: profileData.firstName,
                            lastName: profileData.lastName,
                            phoneNo: profileData.phoneNo,
                            educationLevel: profileData.educationLevel,
                            profession: profileData.profession,
                            careerLevel: profileData.careerLevel,
                            professionText: profileData.professionText,
                            careerLevelText: profileData.careerLevelText,
                            country: profileData.country,
                            state: profileData.state,
                            city: profileData.city,
                          });
                          
                        
                        }
                      }}
                      disabled={updating}
                    >
                      Reset
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default ExpertProfile;